export var OneOnOneStatus;
(function (OneOnOneStatus) {
    OneOnOneStatus["SCHEDULED"] = "scheduled";
    OneOnOneStatus["IN_PROGRESS"] = "in-progress";
    OneOnOneStatus["READY_FOR_SUBMISSION"] = "ready-for-submission";
    OneOnOneStatus["COMPLETED"] = "completed";
})(OneOnOneStatus || (OneOnOneStatus = {}));
export var OneOnOneMeetingType;
(function (OneOnOneMeetingType) {
    OneOnOneMeetingType["MANAGER_EMPLOYEE"] = "manager-employee";
    OneOnOneMeetingType["PROFESSIONAL"] = "professional";
})(OneOnOneMeetingType || (OneOnOneMeetingType = {}));
